export enum OrderFormRouteType {
  CHEAPEST = 'cheapest',
  FASTEST = 'fastest',
  ALTERNATIVE = 'alternative',
}
